import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { Compartment } from '../models/Compartment'

type SaveCompartmentPayload = {
  compartment: Record<string, unknown>
}

export const saveCompartment = createAsyncThunk<Compartment, SaveCompartmentPayload, ThunkApiContext>('compartments/saveCompartment', async ({ compartment }: SaveCompartmentPayload, { dispatch }) => {
  const response = await OLMSApiService.post<Compartment>('compartment/save', compartment)

  if (!response) {
    dispatch(setToast({
      open: true,
      severity: 'error',
      title: 'Save compartment',
      content: 'Failed to save compartment',
    }))
    throw new Error('Failed to save compartment')
  }

  dispatch(setToast({
    open: true,
    severity: 'success',
    title: 'Save compartment',
    content: 'Successfully saved compartment',
  }))

  return response
})